<template>
  <div></div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'TalentqTest',

    computed: {
      ...mapGetters('interview_talentq', ['get_assessment_by_code_id']),

      id() {
        return +this.$router.history.current.params.id;
      },

      assessment() {
        return this.get_assessment_by_code_id(this.id);
      }
    },

    created() {
      location.assign(this.assessment.url);
    }
  };
</script>
